import { useReducer } from 'react';
import { v4 } from 'uuid';
import { CLEAR_INFO, CLEAR_NOTIFICATION, CLEAR_ERROR, SET_INFO, SET_LOADING, SET_NOTIFICATION, SET_LOADING_ELEMENT_NAME, CLEAR_INFORMATION, REMOVE_BANNER, ADD_BANNER, SET_MAJOR_UPDATE_MODAL } from '../types/contextTypes';
import UIContext from './UIContext';
import UIReducer from './UIReducer';

const UIState = (props) => {
  const initialState = {
    info: '',
    notifications: [],
    error: null,
    errorBoundary: null,
    TTL: 9000,
    processStarted: false,
    loadingElementName: '',
    loading: false,
    signalRIsConnected: false,
    banners:[],
    isMajorUpdateModalVisible: false,
    processIcons: [
      'fas fa-spa',
      'fas fa-share-square',
      'fas fa-arrows-alt',
      'fas fa-tractor',
      'fas fa-balance-scale',
      'fas fa-dumpster',
      'fas fa-trash',
      'fas fa-clipboard',
      'fas fa-camera'
    ],
  };

  const [state, dispatch] = useReducer(UIReducer, initialState);

  const setLoading = (isLoading) => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };

  const setLoadingElementName = (name) => {
    dispatch({
      type: SET_LOADING_ELEMENT_NAME,
      payload: name
    })
  }

  const setInfo = (text) => {
    dispatch({
      type: SET_INFO,
      payload: text,
    });
  };

  const clearInfo = () => {
    dispatch({
      type: CLEAR_INFO,
    });
  };

  const addNotification = (text, type = 'info', errorBoundary = null) => {
    const id = v4();

    if (type === 'error-stay') {
      dispatch({
        type: SET_NOTIFICATION,
        payload: { id, text, type, errorBoundary },
      });
      return;
    }

    dispatch({
      type: SET_NOTIFICATION,
      payload: { id, text, type },
    });

    let actualTTL = state.TTL;
    if (type === 'info') {
      actualTTL = 5000;
    }
    else if (type === 'success') {
      actualTTL = 3000;
    }
    else if (type === 'error') {
      actualTTL = 9000;
    };

    setTimeout(() => removeNotification(id), actualTTL);
  };

  const addRedInfoNotification = (text, type = 'info') => {
    const id = v4();
    type = 'info-red'
    dispatch({
      type: SET_NOTIFICATION,
      payload: { id, text, type },
    });

    setTimeout(() => removeNotification(id), 3000);
  }

  const removeError = () => {
    dispatch({
      type: CLEAR_ERROR
    });
  }

  const removeInformation = () => {
    dispatch({
      type: CLEAR_INFORMATION
    });
  }

  const removeNotification = (id) => {
    dispatch({
      type: CLEAR_NOTIFICATION,
      payload: id,
    });
  };

  const addBanner = (text, showCloseButton = false) => {
    const newBanner = {
      id: v4(),
      text,
      showCloseButton
    };

    dispatch({
      type: ADD_BANNER,
      payload: { banner: newBanner }
    });
  };

  const removeBanner = (id) => {
    dispatch({
      type: REMOVE_BANNER,
      payload: { id }
    });
  };

  const setIsMajorUpdatePopupVisible = (isVisible) => {
    dispatch({
      type: SET_MAJOR_UPDATE_MODAL,
      payload: isVisible
    });
  };

  return (
    <UIContext.Provider
      value={{
        ...state,
        addNotification,
        addRedInfoNotification,
        removeNotification,
        removeError,
        removeInformation,
        setInfo,
        clearInfo,
        setLoading,
        setLoadingElementName,
        addBanner,
        removeBanner,
        setIsMajorUpdatePopupVisible,
        isMajorUpdateModalVisible: state.isMajorUpdateModalVisible
      }}
    >
      {props.children}
    </UIContext.Provider>
  );
};

export default UIState;
